var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SecondaryAction',{attrs:{"icon":"sr-2 sr-v2-paper-airplane","text":"Message"},on:{"click":function($event){return _vm.compose()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }